
{
  "familyId": "STU-ALFABET",
  "questions": [
    {
      "id": "STU-ALFABET-001",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een bibliothecaris heeft vier boeken gesorteerd op auteursnaam: Bram, Anna, Carla, David. Een leerling zegt: \"Dit klopt, want B komt voor A.\" Wat is er fout?",
      "context": null,
      "options": [
        "Anna (A) moet vóór Bram (B) staan — A komt eerder in het alfabet",
        "De leerling heeft gelijk — B komt voor A",
        "Carla moet als eerste staan want C is de mooiste letter",
        "De volgorde maakt niet uit bij een bibliotheek"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alfabetisch ordenen",
            "content": "In het alfabet: A, B, C, D... Anna begint met A en komt daarom vóór Bram (B). A komt altijd eerder dan B.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_first",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De leerling denkt dat B voor A komt, maar dat klopt niet. In het alfabet is de volgorde: A, B, C, D... Anna begint met A en moet daarom als eerste staan, vóór Bram (B). De juiste volgorde is: Anna, Bram, Carla, David.",
        "solutionSteps": [
          "Controleer de bewering: komt B vóór A in het alfabet?",
          "Nee — het alfabet begint met A, B, C, D...",
          "Anna (A) moet vóór Bram (B) staan",
          "Juiste volgorde: Anna, Bram, Carla, David"
        ],
        "distractorExplanations": {
          "0": "Goed! A komt vóór B in het alfabet. Anna moet als eerste staan, niet Bram.",
          "1": "Je dacht waarschijnlijk dat B vóór A komt. Maar het alfabet begint met A, dan B. Onthoud: A is de allereerste letter van het alfabet.",
          "2": "Je dacht waarschijnlijk dat je een letter kiest op basis van voorkeur. Maar alfabetisch ordenen volgt altijd de vaste volgorde van het alfabet: A, B, C, D... Onthoud: het alfabet bepaalt de volgorde, niet je eigen keuze.",
          "3": "Je dacht waarschijnlijk dat de volgorde niet uitmaakt. Maar in een bibliotheek is alfabetische volgorde essentieel om boeken terug te vinden. Onthoud: zonder vaste volgorde kun je niets terugvinden."
        }
      }
    },
    {
      "id": "STU-ALFABET-002",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een archivaris ordent documenten. Welke twee woorden staan alfabetisch naast elkaar? 'boom, auto, fiets, deur'",
      "context": null,
      "options": ["auto, boom", "boom, deur", "deur, fiets", "auto, fiets"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alfabetisch naast elkaar",
            "content": "Sorteer de woorden: auto (A), boom (B), deur (D), fiets (F). A en B staan naast elkaar in het alfabet, dus auto en boom staan naast elkaar.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_adjacent",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Sorteer eerst alle woorden alfabetisch, kijk dan welke naast elkaar staan. Eerste letters: boom (B), auto (A), fiets (F), deur (D). Alfabetische volgorde: auto (A), boom (B), deur (D), fiets (F). A en B staan direct naast elkaar in het alfabet → auto en boom staan naast elkaar.",
        "solutionSteps": [
          "Eerste letters: auto (A), boom (B), deur (D), fiets (F)",
          "Alfabetische volgorde: A, B, D, F",
          "A en B staan direct naast elkaar → auto en boom"
        ],
        "distractorExplanations": {
          "0": "Goed! Auto (A) en boom (B) staan alfabetisch naast elkaar — er zit geen letter tussen A en B.",
          "1": "Je dacht waarschijnlijk dat boom en deur naast elkaar staan. Maar tussen B en D zit nog de C. Onthoud: 'naast elkaar' betekent dat er geen letter tussen zit.",
          "2": "Je dacht waarschijnlijk dat deur en fiets naast elkaar staan. Maar tussen D en F zit nog de E. Onthoud: controleer of er letters tussen zitten.",
          "3": "Je dacht waarschijnlijk dat auto en fiets naast elkaar staan. Maar tussen A en F zitten B, C, D en E. Onthoud: sorteer eerst alle woorden en kijk welke direct naast elkaar staan."
        }
      }
    },
    {
      "id": "STU-ALFABET-003",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een redacteur zoekt in een woordenboek het woord 'kamer'. Tussen welke woorden vindt ze dit?",
      "context": null,
      "options": ["kaars en kast", "jas en kast", "kast en lamp", "lamp en muur"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordenboek gebruiken",
            "content": "Kijk naar de eerste twee letters van 'kamer': KA. Vergelijk: kaars (KAA), kamer (KAM), kast (KAS). Alfabetisch: KAA < KAM < KAS.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "dictionary_alphabetical",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij woorden met dezelfde beginletter, vergelijk de tweede en derde letter. 'Kamer' begint met KA. Vergelijk de derde letter: kaars (KAA-rs), kamer (KAM-er), kast (KAS-t). Alfabetisch: A < M < S, dus kaars < kamer < kast. 'Kamer' staat tussen 'kaars' en 'kast'.",
        "solutionSteps": [
          "'Kamer' begint met KA",
          "Vergelijk derde letter: kaars (A), kamer (M), kast (S)",
          "A < M < S → kaars < kamer < kast",
          "'Kamer' staat tussen 'kaars' en 'kast'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Kamer' staat tussen 'kaars' en 'kast' (KAA < KAM < KAS).",
          "1": "Je dacht waarschijnlijk dat je breed zoekt. Maar 'kamer' staat preciezer tussen 'kaars' en 'kast'. Onthoud: in een woordenboek zoek je zo nauwkeurig mogelijk.",
          "2": "Je dacht waarschijnlijk dat 'kamer' na 'kast' komt. Maar KAM komt vóór KAS in het alfabet (M < S). Onthoud: vergelijk letter voor letter.",
          "3": "Je dacht waarschijnlijk dat 'kamer' bij de L of M hoort. Maar 'kamer' begint met K, dus het komt vóór 'lamp' (L) en 'muur' (M). Onthoud: K < L < M."
        }
      }
    },
    {
      "id": "STU-ALFABET-004",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een docent maakt een woordenlijst en zet \"zebra\" als eerste woord. Een leerling zegt: \"Dat klopt niet, zebra hoort als laatste.\" Wie heeft gelijk en waarom?",
      "context": null,
      "options": [
        "De leerling — Z is de laatste letter, dus zebra komt als laatste",
        "De docent — Z is een bijzondere letter die altijd vooraan staat",
        "Geen van beiden — zebra hoort in het midden bij de M",
        "Allebei — het maakt niet uit waar zebra staat"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Laatste in het alfabet",
            "content": "Z is de laatste letter van het alfabet. Woorden die met Z beginnen komen daarom altijd als laatste in een alfabetische lijst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_last",
      "variantIndex": 6,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De leerling heeft gelijk. Z is de laatste letter van het alfabet (A, B, C, ... X, Y, Z). Woorden die met Z beginnen komen daarom altijd als laatste in een alfabetische lijst. De docent heeft \"zebra\" op de verkeerde plek gezet.",
        "solutionSteps": [
          "Controleer: waar staat Z in het alfabet?",
          "Z is de allerlaatste letter (na Y)",
          "Woorden met Z komen als laatste in een alfabetische lijst",
          "De leerling heeft gelijk — zebra hoort als laatste"
        ],
        "distractorExplanations": {
          "0": "Goed! Z is de laatste letter van het alfabet. Zebra hoort als laatste in een alfabetische lijst.",
          "1": "Je dacht waarschijnlijk dat Z een speciale positie heeft. Maar Z volgt gewoon de alfabetische volgorde — het is de 26e en laatste letter. Onthoud: geen enkele letter is \"bijzonder\" in het alfabet.",
          "2": "Je dacht waarschijnlijk dat zebra bij de M hoort. Maar zebra begint met Z, niet met M. Onthoud: kijk altijd naar de eerste letter van het woord.",
          "3": "Je dacht waarschijnlijk dat de volgorde niet uitmaakt. Maar bij alfabetisch ordenen is er altijd maar één juiste volgorde. Onthoud: het alfabet bepaalt de vaste volgorde."
        }
      }
    },
    {
      "id": "STU-ALFABET-005",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een secretaresse ordent mappen. De woorden 'slang, spin, sneeuw, stoel' beginnen allemaal met S. Welk woord komt als tweede?",
      "context": null,
      "options": ["sneeuw", "slang", "spin", "stoel"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ordenen op tweede letter",
            "content": "Alle woorden beginnen met S. Kijk dan naar de tweede letter: slang (L), sneeuw (N), spin (P), stoel (T). Alfabetisch: L, N, P, T.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_second_letter",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Als woorden met dezelfde letter beginnen, vergelijk de tweede letter. Alle woorden beginnen met S. Vergelijk de tweede letter: slang (L), sneeuw (N), spin (P), stoel (T). Alfabetisch: L < N < P < T. Volgorde: slang, sneeuw, spin, stoel. 'Sneeuw' komt als tweede.",
        "solutionSteps": [
          "Alle woorden beginnen met S",
          "Tweede letters: slang (L), sneeuw (N), spin (P), stoel (T)",
          "L < N < P < T",
          "Volgorde: slang, sneeuw, spin, stoel → sneeuw is tweede"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Sneeuw' komt als tweede: slang (SL), sneeuw (SN), spin (SP), stoel (ST).",
          "1": "Je dacht waarschijnlijk dat 'slang' als tweede komt. Maar 'slang' komt als eerste (SL komt voor SN). Onthoud: de vraag is welk woord als tweede komt.",
          "2": "Je dacht waarschijnlijk dat 'spin' als tweede komt. Maar 'spin' komt als derde (SP komt na SN). Onthoud: N komt voor P in het alfabet.",
          "3": "Je dacht waarschijnlijk dat 'stoel' als tweede komt. Maar 'stoel' komt als laatste (ST komt na SP). Onthoud: T komt na P in het alfabet."
        }
      }
    }
  ]
}
